module.exports = __webpack_public_path__ + "img/tech_image_16.391eb88a.jpg";